import { combineReducers } from 'redux';
import common from './reducer';
import ta from '../../TA/REDUX/reducer';
import ms from '../../MS/REDUX/reducer';
import tt from '../../TT/REDUX/reducer';
import mt from '../../MT/REDUX/reducer';
import tm from '../../TM/REDUX/reducer';
import sm from '../../SM/REDUX/reducer';
import re from '../../RE/REDUX/reducer';
import nm from '../../NM/REDUX/reducer';
import cm from '../../CM/REDUX/reducer';
import pn from '../../PN/REDUX/reducer';
import pt from '../../PT/REDUX/reducer';

export default combineReducers({ common, ta, ms, tt, mt, tm, sm, re, nm, cm, pn, pt });
